module.exports = __webpack_public_path__ + "img/outdent.f72414e6.svg";